import React, { useState } from 'react';
const MatchStats = () => {
  const [viewMode, setViewMode] = useState<'offensive' | 'defensive'>('offensive');
  const [activeStatTab, setActiveStatTab] = useState('index');
  const statCategories = {
    index: [{
      stat: 'Overall Rating',
      home: 89.5,
      away: 87.2
    }, {
      stat: 'Efficiency',
      home: 112.4,
      away: 108.6
    }, {
      stat: 'Success Rate',
      home: 52.3,
      away: 48.9
    }],
    scoring: [{
      stat: 'Field Goal %',
      home: 48.8,
      away: 45.2
    }, {
      stat: '3PT %',
      home: 37.5,
      away: 33.3
    }, {
      stat: 'Free Throw %',
      home: 82.1,
      away: 78.6
    }, {
      stat: 'Points in Paint',
      home: 46,
      away: 52
    }, {
      stat: 'Fast Break Points',
      home: 14,
      away: 12
    }],
    playmaking: [{
      stat: 'Assists',
      home: 24,
      away: 22
    }, {
      stat: 'Assist/Turnover',
      home: 1.85,
      away: 1.47
    }, {
      stat: 'Ball Movement',
      home: 58.2,
      away: 54.8
    }, {
      stat: 'Second Chance Points',
      home: 13,
      away: 11
    }],
    defense: [{
      stat: 'Steals',
      home: 8,
      away: 7
    }, {
      stat: 'Blocks',
      home: 5,
      away: 3
    }, {
      stat: 'Defensive Rating',
      home: 104.2,
      away: 106.8
    }, {
      stat: 'Opponent FG%',
      home: 45.2,
      away: 48.8
    }]
  };
  const radarMetrics = {
    labels: ['Points', 'FG%', '3PT%', 'Rebounds', 'Assists', 'Steals'],
    home: [112, 48.8, 37.5, 53, 24, 8],
    away: [108, 45.2, 33.3, 46, 22, 7],
    maxValues: [120, 60, 45, 60, 30, 10]
  };
  const calculateRadarPoints = (values: number[], maxValues: number[]) => {
    const points = [];
    const sides = values.length;
    const centerX = 100;
    const centerY = 100;
    const radius = 80;
    for (let i = 0; i < sides; i++) {
      const angle = i * 2 * Math.PI / sides - Math.PI / 2;
      const value = values[i] / maxValues[i];
      const x = centerX + radius * value * Math.cos(angle);
      const y = centerY + radius * value * Math.sin(angle);
      points.push(`${x},${y}`);
    }
    return points.join(' ');
  };
  const getActiveStats = () => {
    return statCategories[activeStatTab] || [];
  };
  const getBetterTeam = (stat, home, away) => {
    const lowerIsBetter = ['Turnovers', 'Opponent FG%'];
    if (lowerIsBetter.includes(stat)) {
      return home < away ? 'home' : home > away ? 'away' : 'tie';
    }
    return home > away ? 'home' : home < away ? 'away' : 'tie';
  };
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-379" data-mp="1sfhez7lqez2g">
      <div className="flex justify-between items-center mb-6" data-id="element-380" data-mp="1nhfy8tbs3bu5">
        <h2 className="text-xl font-bold" data-id="element-381" data-mp="1nhz3pak8s7ra">Team Statistics</h2>
        <div className="bg-gray-100 rounded-lg p-1" data-id="element-382" data-mp="1v1i32rdsmdm1">
          <button onClick={() => setViewMode('offensive')} className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${viewMode === 'offensive' ? 'bg-white shadow text-blue-600' : 'text-gray-600'}`} data-id="element-383" data-mp="1uyvxgxagq86g">
            Offensive
          </button>
          <button onClick={() => setViewMode('defensive')} className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${viewMode === 'defensive' ? 'bg-white shadow text-blue-600' : 'text-gray-600'}`} data-id="element-384" data-mp="29p366lao4cty">
            Defensive
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6 mb-8" data-id="element-385" data-mp="1m2d4xm658mae">
        {/* Combined Radar Chart */}
        <div className="border-2 border-gray-200 rounded-lg p-4" data-id="element-386" data-mp="1r0of5y0coyt5">
          <div className="text-center mb-2 font-semibold" data-id="element-387" data-mp="2xee31rowdn2t">Team Comparison</div>
          <svg viewBox="0 0 200 200" className="w-full h-auto" data-id="element-388" data-mp="32e0nal3583l4">
            {/* Background circles */}
            {[0.2, 0.4, 0.6, 0.8, 1].map((scale, i) => <polygon key={i} points={calculateRadarPoints(radarMetrics.maxValues.map(() => scale * 100), radarMetrics.maxValues.map(() => 100))} fill="none" stroke="#e5e7eb" strokeWidth="0.5" data-id="element-389" data-mp="301osc9j3ypx9" data-mpi={i} />)}
            {/* Axis lines */}
            {radarMetrics.labels.map((_, i) => {
            const angle = i * 2 * Math.PI / radarMetrics.labels.length - Math.PI / 2;
            return <line key={i} x1="100" y1="100" x2={100 + 80 * Math.cos(angle)} y2={100 + 80 * Math.sin(angle)} stroke="#e5e7eb" strokeWidth="0.5" data-id="element-390" data-mp="3so159dntboni" data-mpi={i} />;
          })}
            {/* Lakers (away) radar - draw first so it's behind */}
            <polygon points={calculateRadarPoints(radarMetrics.away, radarMetrics.maxValues)} fill="rgba(59, 130, 246, 0.3)" stroke="#3b82f6" strokeWidth="2" data-id="element-391" data-mp="l5co82lje778" />
            {/* Knicks (home) radar */}
            <polygon points={calculateRadarPoints(radarMetrics.home, radarMetrics.maxValues)} fill="rgba(239, 68, 68, 0.3)" stroke="#ef4444" strokeWidth="2" data-id="element-392" data-mp="g3dmex5g3ice" />
            {/* Labels */}
            {radarMetrics.labels.map((label, i) => {
            const angle = i * 2 * Math.PI / radarMetrics.labels.length - Math.PI / 2;
            const x = 100 + 95 * Math.cos(angle);
            const y = 100 + 95 * Math.sin(angle);
            return <text key={i} x={x} y={y} textAnchor="middle" dominantBaseline="middle" className="text-[8px] fill-gray-600" data-id="element-393" data-mp="3jl5iammpcmfv" data-mpi={i}>
                  {label}
                </text>;
          })}
          </svg>
          <div className="mt-4 flex justify-center space-x-8" data-id="element-394" data-mp="2ls5wvlhk56no">
            <div className="flex items-center" data-id="element-395" data-mp="2ltp9n2408zkp">
              <div className="w-4 h-4 bg-blue-500 rounded-full mr-2 opacity-60" data-id="element-396" data-mp="3jfms4zidx4wn"></div>
              <span className="text-sm" data-id="element-397" data-mp="3egtjplhyg43c">Los Angeles Lakers</span>
            </div>
            <div className="flex items-center" data-id="element-398" data-mp="3eeqpep9rrost">
              <div className="w-4 h-4 bg-red-500 rounded-full mr-2 opacity-60" data-id="element-399" data-mp="39gxejixiu6m7"></div>
              <span className="text-sm" data-id="element-400" data-mp="34j5g062dfm91">New York Knicks</span>
            </div>
          </div>
        </div>
        {/* Stats Categories Tabs */}
        <div className="border-2 border-gray-200 rounded-lg p-4" data-id="element-401" data-mp="1y3v12wqpxx69">
          <div className="flex space-x-4 mb-6 border-b" data-id="element-402" data-mp="1t37845ixj69e">
            {Object.keys(statCategories).map(category => <button key={category} onClick={() => setActiveStatTab(category)} className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${activeStatTab === category ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-800'}`} data-id="element-403" data-mp="8n0v71it2rb5">
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </button>)}
          </div>
          <div className="space-y-4" data-id="element-404" data-mp="waqro1o1hoe8">
            {getActiveStats().map((item, index) => {
            const betterTeam = getBetterTeam(item.stat, item.home, item.away);
            return <div key={index} className="grid grid-cols-12 gap-2 items-center" data-id="element-405" data-mp="168y7uiai82f6" data-mpi={index}>
                  <div className={`col-span-2 text-right ${betterTeam === 'away' ? 'font-bold text-blue-600' : ''}`} data-id="element-406" data-mp="332rxc441frhp">
                    {typeof item.away === 'number' && item.stat.includes('%') ? `${item.away}%` : item.away}
                  </div>
                  <div className="col-span-8" data-id="element-407" data-mp="18rjqlqyp1maj">
                    <div className="flex h-4 bg-gray-100 rounded-full overflow-hidden" data-id="element-408" data-mp="1nisdvtf4ivki">
                      <div className="bg-blue-500 h-full" style={{
                    width: `${item.away / (item.away + item.home) * 100}%`,
                    transition: 'width 0.5s ease'
                  }} data-id="element-409" data-mp="1iiw93rylr03w"></div>
                      <div className="bg-red-500 h-full" style={{
                    width: `${item.home / (item.away + item.home) * 100}%`,
                    transition: 'width 0.5s ease'
                  }} data-id="element-410" data-mp="14sawum3nloez"></div>
                    </div>
                    <div className="text-xs text-center text-gray-600 mt-1" data-id="element-411" data-mp="2b7trdv2tcwwn">
                      {item.stat}
                    </div>
                  </div>
                  <div className={`col-span-2 ${betterTeam === 'home' ? 'font-bold text-red-600' : ''}`} data-id="element-412" data-mp="2nqz37j4dcez5">
                    {typeof item.home === 'number' && item.stat.includes('%') ? `${item.home}%` : item.home}
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </div>;
};
export default MatchStats;